import React from 'react';
import ImportantEventTable from '../../ImportantEventTable';

export default function ImportantEvent(props) {
    const { data } = props;
    return (
        <div>
            <div style={{ lineHeight: '48px' }}>2.重大事件发生明细</div>
            <ImportantEventTable data={data} />
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/home/TeachingDetail/tables/ImportantEvent.js